import axios from 'axios';
import React, { useEffect, useState } from 'react';
import Advantages from '../components/Card/Advantages';
import Icons from '../components/Icons';
import ListImage from '../components/List/ListImage';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

export default function LandingPage(props) {
  const [places, setPlaces] = useState('');

  useEffect(() => {
    axios.get('http://localhost:3004/wisatabudaya').then((res) => {
      setPlaces(res.data);
      console.log(res.data);
    });
  }, []);

  return (
    <div>
      <div className="container mx-auto px-[4%]">
        <Navbar />
      </div>
      <hr className="border-[0.5px] border-[#EAEAEA] divide-solid mb-10" />

      {/* Hero */}
      <div className="container mx-auto px-[4%] font-[Heebo]">
        {/* <div className="flex flex-col-reverse lg:flex-row lg:gap-8 items-center justify-between"> */}
        <div className="lg:grid lg:grid-cols-2 grid-cols-none flex lg:flex-none flex-col-reverse lg:gap-8 items-center justify-between">
          <div className="flex flex-col lg:mt-0 md:-mt-[50%] -mt-[65%] z-40 lg:basis-1/2 basis-0">
            <div className="flex flex-col lg:text-left text-center lg:mx-0 mx-[26%]">
              <p className="lg:text-black text-white lg:text-5xl text-base lg:font-bold font-medium">
                Yuk, Explore Keunikan Tegal Bahari
              </p>
              <p className="lg:text-xl text-xs lg:text-[#888888] text-[#EAEAEA] lg:w-[80%] mt-5">
                Dijuluki sebegai Kota Bahari, Tegal menyimpan berbagai hal-hal luar biasa yang
                menarik untuk dijelajahi.
              </p>
            </div>
            <div className="lg:grid lg:grid-cols-4 flex flex-col items-center rounded-[10px] shadow-landingpage lg:mt-24 mt-[55%] p-4">
              <div className="grid grid-cols-3 col-span-3 items-center">
                <div className="flex text-center items-center">
                  <div className="w-full">
                    <p className="text-[#096346] lg:text-2xl text-lg font-bold">120</p>
                    <p className="text-[#0CBB83] text-xs">Wisata & Budaya</p>
                  </div>
                  <hr className="border border-[#EAEAEA] w-0.5 h-[80px] lg:mx-0 mx-3" />
                </div>
                <div className="flex text-center items-center">
                  <div className="w-full">
                    <p className="text-[#096346] lg:text-2xl text-lg font-bold">40</p>
                    <p className="text-[#0CBB83] text-xs">Event</p>
                  </div>
                  <hr className="border border-[#EAEAEA] w-0.5 h-[80px] lg:mx-0 mx-3" />
                </div>
                <div className="flex flex-col text-center items-center">
                  <p className="text-[#096346] lg:text-2xl text-lg font-bold">87</p>
                  <p className="text-[#0CBB83] text-xs">Tempat Menarik</p>
                </div>
              </div>
              <button className="bg-[#0CBB83] text-white py-3 rounded-lg lg:w-auto w-full lg:mt-0 mt-3 text-xs">
                Explore
              </button>
            </div>
          </div>
          <img
            src="/assets/images/image-landingpage.png"
            alt="image-landingpage"
            className="lg:basis-1/2 basis-0"
          />
        </div>
      </div>
      {/* ----- */}

      {/* Features */}
      <div className="container mx-auto px-[4%] mt-[10%] font-[Rubik]">
        <div className="flex flex-col items-center justify-center text-center">
          <p className="font-medium md:text-5xl text-2xl text-black ">
            Apa Saja Fitur yang Kami Miliki?
          </p>
          <p className="md:text-xl text-sm text-[#666666] xl:w-[40%] w-auto mt-5">
            Anda dapat menemukan keberagaman wilayah Tegal mulai dari, info wisata, event,
            kebudayaan dan info menarik lainnya.
          </p>
        </div>
        <div className="grid lg:grid-cols-4 sm:grid-cols-2 lg:gap-4 gap-8 mt-[8%]">
          <div>
            <Icons src="/assets/images/ic-wisata.svg" alt="ic-wisata" />
            <div className="mt-7">
              <p className="text-black text-xl font-medium mb-3">Wisata & Budaya</p>
              <p className="text-[#999999] w-[210px] text-sm mb-7">
                Dikenal sebagai Kota Bahari, wilayah Tegal memiliki beranekaragam wisata dan budaya
                yang sangat menarik.
              </p>
              <a href="#" className="text-[#0CBB83] font-medium text-xs">
                LIHAT SELENGKAPNYA
              </a>
            </div>
          </div>
          <div className="lg:ml-0 sm:ml-auto ml-0">
            <Icons src="/assets/images/ic-event.svg" alt="ic-event" />
            <div className="mt-7">
              <p className="text-black text-xl font-medium mb-3">Event</p>
              <p className="text-[#999999] w-[210px] text-sm mb-7">
                Berbagai event mulai dari konser musik, bazaar kuliner hingga pagelaran budaya
                sering diadakan di daerah Tegal.
              </p>
              <a href="#" className="text-[#0CBB83] font-medium text-xs">
                LIHAT SELENGKAPNYA
              </a>
            </div>
          </div>
          <div>
            <Icons src="/assets/images/ic-explore.svg" alt="ic-explore" />
            <div className="mt-7">
              <p className="text-black text-xl font-medium mb-3">Explore</p>
              <p className="text-[#999999] w-[210px] text-sm mb-7">
                Mulai dari laut, gunung, danau serta pemandangan alam yang indah membuat Tegal
                menarik untuk dikunjungi.
              </p>
              <a href="#" className="text-[#0CBB83] font-medium text-xs">
                LIHAT SELENGKAPNYA
              </a>
            </div>
          </div>
          <div className="lg:ml-0 sm:ml-auto ml-0">
            <Icons src="/assets/images/ic-kontributor.svg" alt="ic-kontributor" />
            <div className="mt-7">
              <p className="text-black text-xl font-medium mb-3">Kontributor</p>
              <p className="text-[#999999] w-[210px] text-sm mb-7">
                Ingin berperan memajukan Tegal? Ayo bergabung menjadi kontributor dengan mengisi
                berbagai info yang ada di Tegal.
              </p>
              <a href="#" className="text-[#0CBB83] font-medium text-xs">
                LIHAT SELENGKAPNYA
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* ----- */}

      {/* List */}
      <div className="container mx-auto px-[4%] mt-[10%]">
        <div className="grid grid-cols-3 gap-4 justify-center items-center lg:w-2/3 w-auto mx-auto">
          <button className="border rounded-lg text-[#0CBB83] hover:text-white border-[#0CBB83] hover:bg-[#0CBB83] bg-white py-4 w-auto">
            Wisata & Budaya
          </button>
          <button className="border rounded-lg text-[#0CBB83] hover:text-white border-[#0CBB83] hover:bg-[#0CBB83] bg-white py-4 w-auto">
            Event
          </button>
          <button className="border rounded-lg text-[#0CBB83] hover:text-white border-[#0CBB83] hover:bg-[#0CBB83] bg-white py-4 w-auto">
            Explore
          </button>
        </div>
        <div className="flex flex-col justify-center items-center text-center mt-8">
          <p className="text-xl text-[#444444] font-medium">Wisata & Budaya yang Sedang Hits</p>
          <p className="text-[#999999] text-sm w-1/3 mt-3">
            Lokasinya yang berada di tengah Pulau Jawa menjadikan Tegal sebagai wilayah strategis
            dan cocok.
          </p>
        </div>
        {places.length > 0 ? (
          <div className="grid lg:grid-cols-3 grid-cols-2 gap-7 mt-10">
            {places.map((place) => (
              <div key={place.imgId}>
                <ListImage src={place.image} title={place.title} address={place.address} />
              </div>
            ))}
          </div>
        ) : null}
      </div>
      {/* ----- */}

      {/* Advantages */}
      <div className="container mx-auto px-[4%] flex lg:flex-row flex-col justify-between items-center mt-[15%] mb-[10%]">
        <div className="mr-[5%] w-[90%] lg:text-left text-center">
          <p className="font-medium text-xs text-primary">ADA APA SIH DI TEGAL?</p>
          <p className="font-medium lg:text-4xl text-2xl text-[#222222] lg:mb-7 mb-5">
            Kenapa Tegal Harus Anda Kunjungi?-
          </p>
          <p className="lg:text-xl text-sm text-[#666666] lg:mb-14 mb-8">
            keanekaragaman alam dan budaya membuat Tegal wajib masuk dalam list daerah yang harus
            Anda kunjungi.
          </p>
          <button className="bg-[#0CBB83] lg:text-base text-xs text-white rounded-lg px-8 py-4">
            Explore Sekarang
          </button>
        </div>
        <div className=" lg:mt-0 mt-5">
          <Advantages
            src="/assets/images/advantages-1.svg"
            alt="advantages-1"
            title="Lokasi Startegis"
            desc="Lokasinya yang berada di tengah Pulau Jawa menjadikan Tegal sebagai wilayah strategis dan cocok untuk bisnis maupun berwisata. "
          />
          <Advantages
            src="/assets/images/advantages-2.svg"
            alt="advantages-2"
            title="Kekayaan Alam Lengkap"
            desc="Tegal memiliki keberagaman alam yang lengkap sehingga dijuluki sebagai Kota Bahari, mulai dari laut, gunung hingga danau semua ada. Hal itu menjadikan Tegal memiliki keindahan alam yang sangat mempesona."
          />
          <Advantages
            src="/assets/images/advantages-3.svg"
            alt="advantages-3"
            title="Banyak Tempat Menarik"
            desc="Tak hanya tentang keberagaman alam dan budaya, Tegal juga memiliki berbagai destinasi modern yang biasa dijumpai di kota besar. Anda bisa dengan mudah menemukan fasilitas hiburan khas kota besar."
          />
        </div>
      </div>
      {/* ----- */}

      <Footer />
    </div>
  );
}
